interface MetaRow {
  label: string;
  value: string;
  mono?: boolean;
}

interface MetaDotsProps {
  rows: MetaRow[];
}

/**
 * Lista key-value com dot leaders entre label e value (estilo TOC editorial).
 *
 * Exemplo:
 *   Provider  ........ Anthropic
 *   Modelo    ........ claude-sonnet-4-5
 *   Duração   ........ 24s
 *
 * E5 (docs/01 §6): decoração funcional — dots não são ornamentação, são
 * linha de leitura óptica. Tipografia editorial.
 */
export function MetaDots({ rows }: MetaDotsProps) {
  return (
    <dl className="space-y-1 font-sans text-sm">
      {rows.map((r) => (
        <div key={r.label} className="flex items-baseline gap-2">
          <dt className="text-[var(--ink-tertiary)]">{r.label}</dt>
          <span
            aria-hidden
            className="flex-1 translate-y-[-2px] border-b border-dotted border-[var(--border-default)]"
          />
          <dd
            className={
              r.mono
                ? 'font-mono tabular-nums text-[var(--ink-primary)]'
                : 'text-[var(--ink-primary)]'
            }
          >
            {r.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
